import {
  Eye,
  EyeOff,
  Flag,
  Heart,
  Pencil,
  Pin,
  PinOff,
  Trash2,
} from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { XStack, YStack } from "tamagui";
import { Body } from "../../../ui/Body";
import { Group } from "../../../ui/Group";
import { Sheet, type SheetProps } from "../../../ui/Sheet";
import { Title } from "../../../ui/Title";

export const FeedItemManageSheet: React.FC<
  SheetProps & {
    pinOption?: { show: boolean; isPinned: boolean; callback: () => void };
    likeOption?: { show: boolean; callback: () => void };
    editOption: { show: boolean; callback: () => void };
    deleteOption: { show: boolean; callback: () => void };
    hideOption: { show: boolean; isHidden: boolean; callback: () => void };
    reportOption: { show: boolean; callback: () => void };
  }
> = observer(
  ({
    pinOption,
    likeOption,
    editOption,
    deleteOption,
    hideOption,
    reportOption,
    open,
    ...props
  }) => {
    const { t } = useTranslation();

    if (!open) {
      return null;
    }

    return (
      <Sheet open={open} {...props} sheetId="b-reactions">
        <YStack gap="$space.large">
          <Title>{t("business:manage_sheet_more")}</Title>

          <Group>
            {likeOption?.show && (
              <XStack
                cursor={"pointer"}
                alignItems="center"
                gap="$medium"
                onPress={() => {
                  likeOption.callback();
                  props.onOpenChange?.(false);
                }}
              >
                <Body>
                  <Heart />
                </Body>
                <Body>{t("business:manage_sheet_like")}</Body>
              </XStack>
            )}
            {editOption?.show && (
              <XStack
                cursor={"pointer"}
                alignItems="center"
                gap="$medium"
                onPress={() => {
                  editOption.callback();
                  props.onOpenChange?.(false);
                }}
              >
                <Body>
                  <Pencil />
                </Body>
                <Body>{t("business:manage_sheet_edit")}</Body>
              </XStack>
            )}
            {pinOption?.show && (
              <XStack
                cursor={"pointer"}
                alignItems="center"
                gap="$medium"
                onPress={() => {
                  pinOption.callback();
                  props.onOpenChange?.(false);
                }}
              >
                <Body>{pinOption.isPinned ? <PinOff /> : <Pin />}</Body>
                <Body>
                  {pinOption.isPinned
                    ? t("business:manage_sheet_remove_pin")
                    : t("business:manage_sheet_add_pin")}
                </Body>
              </XStack>
            )}
            {hideOption?.show && (
              <XStack
                cursor={"pointer"}
                alignItems="center"
                gap="$medium"
                onPress={() => {
                  hideOption.callback();
                  props.onOpenChange?.(false);
                }}
              >
                <Body>{hideOption.isHidden ? <EyeOff /> : <Eye />}</Body>
                <Body>
                  {hideOption.isHidden
                    ? t("business:manage_sheet_show")
                    : t("business:manage_sheet_hide")}
                </Body>
              </XStack>
            )}
            {deleteOption?.show && (
              <XStack
                cursor={"pointer"}
                alignItems="center"
                gap="$medium"
                onPress={() => {
                  deleteOption.callback();
                  props.onOpenChange?.(false);
                }}
              >
                <Body>
                  <Trash2 />
                </Body>
                <Body>{t("business:manage_sheet_delete")}</Body>
              </XStack>
            )}
            {reportOption?.show && (
              <XStack
                cursor={"pointer"}
                alignItems="center"
                gap="$medium"
                onPress={() => {
                  reportOption.callback();
                  props.onOpenChange?.(false);
                }}
              >
                <Body>
                  <Flag />
                </Body>
                <Body>{t("business:manage_sheet_report")}</Body>
              </XStack>
            )}
          </Group>
        </YStack>
      </Sheet>
    );
  },
);
